<template>
  <div id="app">
    <div class="app-head">
      <h1 class="head-h1">浙江喔刷</h1>
      <div class="head-table">
        <a
          href="#"
          :class="activeName == '/' ? 'active' : ''"
          @click="handleClick('/')"
          >首页</a
        >
        <a
          href="#"
          :class="activeName == '/down' ? 'active' : ''"
          @click="handleClick('/down')"
          >软件下载</a
        >
        <a
          href="#"
          :class="activeName == '/demo' ? 'active' : ''"
          @click="handleClick('/demo')"
          >案例中心</a
        >
        <a
          href="#"
          :class="activeName == '/vipinfo' ? 'active' : ''"
          @click="handleClick('/vipinfo')"
          >会员资讯</a
        >
        <a
          href="#"
          :class="activeName == '/forus' ? 'active' : ''"
          @click="handleClick('/forus')"
          >关于我们</a
        >
        <a
          href="#"
          :class="activeName == '/userset' ? 'active' : ''"
          @click="handleClick('/userset')"
          >用户注册</a
        >
        <a
          href="#"
          :class="activeName == '/userlogin' ? 'active' : ''"
          @click="handleClick('/userlogin')"
          >用户登录</a
        >
      </div>
    </div>
    <router-view />

    <div class="foot">
      <div class="foot-table">
        <a href="#" @click="handleClick('/')">首页</a>
        <a href="#">软件下载</a>
        <a href="#" @click="handleClick('/demo')">案例中心</a>
        <a href="#">用户中心</a>
        <a href="#" @click="handleClick('/forus')">关于我们</a>
      </div>

      <div class="foot-foot">
        <div class="foot-info-box">
          <p class="foot-tel">0579-86399130</p>
          <p>©2021 浙江喔刷版权所有</p>
          <p></p>
        </div>
        <div class="foot-info-box">
          <p>联系QQ：1079361522</p>
          <p>手机号码：15121056742</p>
          <p>联系邮箱：guoqingling@payworth.cn</p>
        </div>
        <div>
          <el-select
            v-model="selectValue"
            @change="selectChange"
            placeholder="请选择"
          >
            <el-option value="" label="友情链接"></el-option>
            <el-option
              value="https://tool.chinaz.com/"
              label="站长工具"
            ></el-option>
            <el-option
              value="https://www.aliyun.com/?utm_content=se_1009145079"
              label="阿里云"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="footer-beian">
      <div class="item">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank"
          >备案号：浙ICP备18054064号-1</a
        >
      </div>
      <div class="item">
        <img src="https://www.zjwspay.com/beian.png" />
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=33078302100888"
          rel="noreferrer"
          target="_blank"
          >浙公网安备33078302100888</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectValue: "",
      activeName: "/",
    };
  },
  created() {
    this.activeName = this.$route.path;
  },

  //监听器
  watch: {
    // 方法1
    $route(to, from) {
      //监听路由是否变化
      this.activeName = to.path;
    },
  },
  methods: {
    handleClick(name) {
      if (this.activeName != name) {
        this.activeName = name;
        this.$router.push({ path: name });
      }
    },
    selectChange(url) {
      if (url) {
        window.open(url);
      }
    },
  },
};
</script>

<style scoped>
.app-head {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  z-index: 999;
  background-color: transparent;
}
.head-h1 {
  width: 50%;
  text-align: center;
  font-size: 32px;
  color: #fff;
}
.head-table {
  background-color: #fff;
  height: 46px;
  line-height: 46px;
}
.head-table a {
  padding: 0 20px;
  font-size: 14px;
  border-right: 1px solid #ccc;
  color: #000;
}
.head-table a:last-child {
  border-right: none;
}
.head-table a.active {
  color: #00a0e9;
}
.head-table a:hover {
  text-decoration: none;
}

.foot {
  padding: 0 300px;
  box-sizing: border-box;
  background-color: #2b2b2b;
}
.foot-table {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #ccc;
  display: flex;
}
.foot-table a {
  width: 100px;
  text-align: center;
  color: rgb(169, 169, 169);
}
.foot-foot {
  display: flex;
  justify-content: space-around;
  padding: 40px 0;
  color: rgb(169, 169, 169);
}
.foot-info-box {
  position: relative;
}
.foot-info-box::after {
  content: "";
  display: block;
  width: 1px;
  height: 50px;
  position: absolute;
  top: 50%;
  right: -50px;
  background-color: rgba(241, 241, 241, 0.2);
  transform: translateY(-50%);
}
.foot-tel {
  font-size: 24px;
}
.footer-beian {
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-beian .item {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.footer-beian .item img {
  height: 22px;
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue